var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.1275V12.75C1.99985 13.7021 2.36185 14.6186 3.01256 15.3136C3.66327 16.0086 4.55397 16.43 5.504 16.4925L5.75 16.5H12.371C12.2159 16.9386 11.9287 17.3184 11.5488 17.587C11.169 17.8557 10.7152 17.9999 10.25 18H5C3.80653 18 2.66193 17.5259 1.81802 16.682C0.974106 15.8381 0.5 14.6935 0.5 13.5V5.25C0.499756 4.78451 0.643892 4.3304 0.912542 3.95026C1.18119 3.57012 1.56113 3.28266 2 3.1275ZM13.25 0C13.8467 0 14.419 0.237053 14.841 0.65901C15.2629 1.08097 15.5 1.65326 15.5 2.25V12.75C15.5 13.3467 15.2629 13.919 14.841 14.341C14.419 14.7629 13.8467 15 13.25 15H5.75C5.15326 15 4.58097 14.7629 4.15901 14.341C3.73705 13.919 3.5 13.3467 3.5 12.75V2.25C3.5 1.65326 3.73705 1.08097 4.15901 0.65901C4.58097 0.237053 5.15326 0 5.75 0H13.25Z",
    fill: "#001D9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a88b7db4a2b4eec95d9e694c7d4f9e2f.svg";
export { ForwardRef as ReactComponent };